@if (opened()) {
  <i class="icon-x-close"></i>
} @else {
  <i class="icon-menu-02"></i>
}
